import { render, staticRenderFns } from "./OverviewPanelComparison.vue?vue&type=template&id=6d1e4e98"
import script from "./OverviewPanelComparison.vue?vue&type=script&lang=js"
export * from "./OverviewPanelComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports